<div class="container">
  <div class="row">
    <div class="col">
      <button type="button" class="btn  btn-outline-danger mx-1" [disabled]="!utility.isAdmin()"
      (click)="onDeleteAppointment(appointment.appointment)">Remove</button>
      <button type="button" class="btn btn-outline-primary mx-1" [hidden]="is_hidden(appointment.appointment)"
      (click)="approve(appointment.appointment.id)">Approve</button>
      <button type="button" class="btn btn-outline-warning mx-1" [hidden]="is_hidden(appointment.appointment)"
      (click)="open(cancel_content)">Cancel</button>
      <button type="button" class="btn btn-outline-dark mx-1"
        [hidden]="is_hidden_appointment(appointment.appointment)" (click)="open(invoice_content)">Invoice
      Payment</button>
    </div>
    <div class="col">
      <a class="btn btn-dark mx-2"
        (click)="print_invoice(appointment?.appointment.patient_id, appointment?.appointment.id)"
      [hidden]="!is_hidden_appointment(appointment.appointment)">Print Invoice</a>
      <button type="button" class="btn btn-outline-success mx-1">Add Service</button>
      <button type="button" class="btn btn-outline-success mx-1">Add items</button>
      @if (package) {
        <button type="button" class="btn btn-outline-danger mx-1" (click)="disablePackage(package)"
        >Remove Package</button>
      }
    </div>
  </div>
  <hr>
    <div class="row">
      <div class="col-lg-6 col-md-6 col-sm-12">
        <div class="card">
          <div class="card-header">
            Patient
            <span class="float-end">
              {{ appointment?.patient.patient_number }}
            </span>
          </div>
          <div class="card-body">
            <h5 class="card-title">{{ appointment?.patient.first_name }} {{ appointment?.patient.last_name }}
              <span class="float-end" style="font-size: small;">
                <a [routerLink]="['/patient_details']"
                [queryParams]="{ id: appointment?.appointment.patient_id }">view patient page</a>
              </span>
            </h5>
            <p class="card-text">Occupation: {{ appointment?.patient.visiting_reason}}</p>
          </div>
          <ul class="list-group list-group-flush">
            <li class="list-group-item">{{ appointment?.patient.gender}}</li>
            <li class="list-group-item">Mobile: <span class="float-end">{{ appointment?.patient.phone}}</span>
          </li>
          <li class="list-group-item">Birth Date: <span class="float-end">{{ appointment?.patient.birth_date |
          date:'dd MMM y'}}</span></li>
          <li class="list-group-item">Birth Date: <span class="float-end">{{ appointment?.patient.birth_date |
          date:'dd MMM y'}}</span></li>
          <li class="list-group-item">Registration Date: <span class="float-end">{{
          appointment?.patient.created_at | date:'dd MMM y'}}</span></li>
        </ul>
        <div class="card-footer text-muted">
          <div class="btn-group mr-2 btn-group" role="group" aria-label="First group" dir="auto">
            <a [routerLink]="['/invoices']" [queryParams]="{id: appointment?.appointment.patient_id}"
              class="btn btn-outline-primary">Check
            Invoices</a>
            <a [routerLink]="['/appointments']"
              [queryParams]="{patient: appointment?.appointment.patient_id}"
            class="btn btn-outline-dark">Check Appointments</a>
          </div>
        </div>
      </div>
      @if (package) {
        <div class="card mt-3">
          <div class="card-header">
            Patient Package
          </div>
          <div class="card-body" style="padding: 0;">
            <table class="table table-bordered" id="excel-table" style="margin: 0;">
              <thead>
                <tr class="table-secondary">
                  <th>Sessions</th>
                  <th>Left</th>
                  <th>Taken</th>
                  <th>Price</th>
                  <th colspan="2">Paied</th>
                  <th>Date</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{{package.no_sessions}}</td>
                  <td>{{package.no_sessions_left}}</td>
                  <td>{{package.no_sessions_took}}</td>
                  <td>{{package.full_price}}</td>
                  <td>{{package.no_sessions_paid}} <small>sessions</small> </td>
                  <td>{{package.paied_amount}} <small>OMR</small> </td>
                  <td>{{package.created_at | date: 'dd/MM/yyyy'}}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      }
      <div class="card mt-3">
        <div class="card-header">
          Appointment
        </div>
        <div class="card-body">
          <h5 class="card-title">
            {{ appointment?.appointment.status | uppercase}}
            @if (!appointment?.appointment.is_happened) {
              <span style="font-size: small;">
                {{ appointment?.appointment.reason_not_happened}}
              </span>
            }
            @if (appointment.appointment.walkin) {
              <span class="badge bg-primary mx-2"
                style="font-size: xx-small;">
                WALK-IN
              </span>
            }
            @if (appointment.appointment.overbooked) {
              <span class="badge bg-primary"
                style="font-size: xx-small;">
                OVERBOOKED
              </span>
            }
          </h5>
          <p class="card-text">{{appointment?.schedule.date_time | date:'hh:mm a'}} -
          {{appointment.schedule.date_time_to | date:'hh:mm a'}}</p>
        </div>
        <ul class="list-group list-group-flush">
          <li class="list-group-item">{{ appointment?.appointment.service}}</li>
          <li class="list-group-item">{{ appointment?.appointment.amount_due | number }} OMR</li>
          <li class="list-group-item">{{ appointment?.appointment.period }} Minunts</li>
        </ul>
      </div>
    </div>
    <div class="col-lg-6 col-md-6 col-sm-12">
      <div class="card">
        <div class="card-header">
          Clinician Notes
        </div>
        <div class="card-body" style="padding: 0px;">
          @if (note.length > 0) {
            <div>
              @for (n of note; track n) {
                <ul class="list-group list-group-flush pb-3">
                  <li class="list-group-item" style="background-color: #f6f6f6;"><b>{{ n?.title}} </b> -
                  <small> {{ n?.open_date | date:'dd MMM y'}}</small>
                  @if (api.canEnter(['doctor', 'admin'])) {
                    <div class="btn-group mr-2 btn-group-sm float-end" role="group" aria-label="First group"
                      >
                      <button type="button" class="btn btn-sm btn-warning"
                        (click)="edit(contentNoteEdit, n)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          fill="currentColor" class="bi bi-pencil" viewBox="0 0 16 16">
                          <path
                            d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168l10-10zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207 11.207 2.5zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293l6.5-6.5zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325z" />
                        </svg>
                      </button>
                      <button type="button" class="btn btn-sm btn-danger" (click)="OnDelete(n.id)">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16"
                          fill="currentColor" class="bi bi-trash" viewBox="0 0 16 16">
                          <path
                            d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z" />
                          <path fill-rule="evenodd"
                            d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z" />
                        </svg>
                      </button>
                    </div>
                  }
                </li>
                <li class="list-group-item">{{ n?.diagnosis }} </li>
                <li class="list-group-item">{{ n?.description }} </li>
              </ul>
            }
          </div>
        }
      </div>
      <div class="card-footer">
        @if (api.canEnter(['doctor', 'admin'])) {
          <button type="button" class="btn btn-sm btn-primary"
          (click)="open(contentNoteNew)">Add New Note</button>
        }
      </div>
    </div>
  </div>
</div>
<div class="row">
  <ng-template #cancel_content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Cancelling Appointment</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="date" class="form-label">Reason</label>
            <select class="form-select" [(ngModel)]="cancel_reason">
              @for (reason of reasons; track reason) {
                <option [ngValue]='reason'>{{
                reason }}</option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="reject(appointment.appointment.id)">Add</button>
    </div>
  </ng-template>
  <ng-template #invoice_content let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Create Invoice</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <div class="row">
          <div class="col">
            <label for="amount_due" class="form-label">Price</label>
            <input type="number" class="form-control" [(ngModel)]="invoice.amount_due" id="amount_due"
              disabled>
          </div>
          <div class="col">
            <label for="amount_due" class="form-label">Quantity</label>
            <input type="number" class="form-control" [(ngModel)]="invoice.quantity" id="amount_due"
              (change)="calculate()" min="1">
          </div>
          <div class="col">
            <label for="amount_due" class="form-label">Total</label>
            <input type="number" class="form-control" [(ngModel)]="invoice.total_amount" id="amount_due"
              disabled>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <label for="date" class="form-label">Payment Type</label>
            <select class="form-select" [(ngModel)]="invoice.payment_type">
              <option [value]="'CASH'">CASH</option>
              <option [value]="'CARD'">CARD</option>
              <option [value]="'BANK'">BANK</option>
              <option [value]="'CHEQUE'">CHEQUE</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <label for="date" class="form-label">Payment Package</label>
            <select class="form-select" [(ngModel)]="invoice.payment_package"
              [disabled]="utility.isDisabled(appointment?.appointment.service, ['hijama', 'Cupping therapy ( dry)', 'Cupping therapy (Medicine)'])">
              <option [value]="'FULL'">FULL</option>
              <option [value]="'INSTALLMENT'">INSTALLMENT</option>
            </select>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col">
            <label for="date" class="form-label">Special Discount</label>
            <select class="form-select" [(ngModel)]="invoice.private_discount">
              <option [ngValue]="0">-- SELECT DISCOUNT --</option>
              @for (offer of offeres; track offer) {
                <option [ngValue]='offer.id'>{{ offer.name }}
                </option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-success" (click)="create(appointment)">Create Invoice</button>
    </div>
  </ng-template>
  <ng-template #contentNoteNew let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Add Note</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <div class="mb-3">
          <label for="diagnosis" class="form-label">Diagnosis</label>
          <textarea class="form-control" id="diagnosis" rows="5" cols="50"
          [(ngModel)]="notes.diagnosis"></textarea>
        </div>
        <div class="mb-3">
          <label for="notes" class="form-label">Notes</label>
          <textarea class="form-control" id="notes" rows="5" cols="50"
          [(ngModel)]="notes.description"></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="OnSumbit()">Submit Note</button>
    </div>
  </ng-template>
  <ng-template #contentNoteEdit let-modal>
    <div class="modal-header">
      <h4 class="modal-title" id="modal-basic-title">Edit Note</h4>
      <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="mb-3">
        <div class="mb-3">
          <label for="diagnosis" class="form-label">Diagnosis</label>
          <textarea class="form-control" id="diagnosis" rows="5" cols="50"
          [(ngModel)]="edit_notes.diagnosis"></textarea>
        </div>
        <div class="mb-3">
          <label for="notes" class="form-label">Notes</label>
          <textarea class="form-control" id="notes" rows="5" cols="50"
          [(ngModel)]="edit_notes.description"></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary" (click)="OnUpdate(note_id)">Edit Note</button>
    </div>
  </ng-template>
</div>
</div>